import Image from "next/image";

import { formatImageUrl } from "@/components/blog/Util";
import type { BlogHeroProps } from "@/types/blog-post";

export default function BlogHero({
  publishDate,
  updateDate,
  title,
  heroImage,
  heroImageAlt = "Article hero image",
  authorName,
  authorAvatarUrl,
  authorHref,
}: BlogHeroProps) {
  return (
    <header className="md:py-20 py-12 md:mb-16 flex flex-col md:flex-row">
      <div className="flex flex-col md:flex-row md:gap-8 w-full">
        <section className="flex flex-col justify-center shrink-0 md:max-w-[50%]">
          {false && publishDate && (
            <time
              suppressHydrationWarning
              className="text-sm text-ash-500 font-normal mt-2 inline"
              itemProp="datePublished"
            >
              Published: {publishDate}
            </time>
          )}

          <h1 className="text-3xl font-bold mb-6 mt-3 leading-[1.15]! md:text-5xl lg:text-6xl" itemProp="headline">
            {title}
          </h1>

          <time suppressHydrationWarning className="text-sm text-ash-500 inline" itemProp="datePublished">
            Last Updated: {updateDate}
          </time>

          {authorName && (
            <address className="flex items-center font-normal mb-6 mt-4">
              {authorAvatarUrl && (
                <Image
                  width={120}
                  height={120}
                  className="rounded-full mr-3 w-10 h-10 object-cover border-white border outline-primary"
                  src={formatImageUrl(authorAvatarUrl)}
                  alt={`${authorName} photo`}
                />
              )}
              {authorHref ? (
                <a href={authorHref} rel="author" className="text-base text-ash-500 font-base no-underline not-italic">
                  Written By: <span className="border-b-2 border-b-ash-200">{authorName}</span>
                </a>
              ) : (
                <span className="text-base text-ash-800">{authorName}</span>
              )}
            </address>
          )}
        </section>
        {heroImage && (
          <section className="w-full">
            <Image
              width={200}
              height={200}
              sizes="(max-width: 768px) 90vw, 45vw"
              className="rounded-2xl shadow-sm w-full object-cover"
              src={`${formatImageUrl(heroImage)}`}
              alt={heroImageAlt}
              loading="eager"
              priority
            />
          </section>
        )}
      </div>
    </header>
  );
}
